import { IAddressGlobal } from '../entities/IGlobal';
import { IAddress } from '../entities/IProfile';

enum ECountrySwitch {
    FR = 'FR',
    US = 'US',
    AUS = 'AUS',
    GB = 'GB'
}
// IAddress (in addressFormatter) is deprecated - please use IAddressGlobal with addressFormatterGlobal and require such an object from the backend
export const addressFormatter = (value: IAddress) => {
    return value ? (
        value.Country !== '' ? (
            Object.values(ECountrySwitch).includes(value.CountryShort as ECountrySwitch) ?
                `${value?.Number}${` ${value?.Street}`}${(value?.Street || value?.Number) && ', '}${value?.ZipCode ? `${value.ZipCode} ` : ''}${value?.City || value?.State}${(value?.City || value?.State) && ', '}${value?.Country}` :
                `${value?.Street}${(value?.Street || value?.Number) && ' '}${value?.Number}${(value?.Street || value?.Number) && ', '}${value?.ZipCode ? `${value.ZipCode} ` : ''}${value?.City || value?.State}${(value?.City || value?.State) && ', '}${value?.Country}`
        ) : (value.City || value.State)
    ) : '';
};

export const addressFormatterGlobal = (value: IAddressGlobal) => {
    return value ? (
        value.country !== '' ? (
            Object.values(ECountrySwitch).includes(value.countryShort as ECountrySwitch) ?
                `${value?.number}${` ${value?.street}`}${(value?.street || value?.number) && ', '}${value?.zipCode ? `${value.zipCode} ` : ''}${value?.city || value?.state}${(value?.city || value?.state) && ', '}${value?.country}` :
                `${value?.street}${(value?.street || value?.number) && ' '}${value?.number}${(value?.street || value?.number) && ', '}${value?.zipCode ? `${value.zipCode} ` : ''}${value?.city || value?.state}${(value?.city || value?.state) && ', '}${value?.country}`
        ) : (value.city || value.state)
    ) : '';
};